import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import './navbar.css';

import pcg_logo_long from '../../assets/images/PCG-logo_long.webp';
import pcg_logo_long_safari from '../../assets/images/PCG-logo_long.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  return (
    <div id="nav-wrapper" className={isScrolled ? 'scrolled' : ''}>
      <nav id="nav" className={isScrolled ? 'scrolled' : ''}>
        <div className="nav left">
          <h1 className="logo">
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : undefined)}>
              <picture>
                <source srcSet={pcg_logo_long} type="image/webp" />
                <source srcSet={pcg_logo_long_safari} type="image/png" />
                <img src={pcg_logo_long} alt="Paper Cactus Games" width="180px" height="100%" />
              </picture>
            </NavLink>
          </h1>
        </div>
        <button className="btn-nav" onClick={toggleMenu}>
          ☰
        </button>
        <div className={`nav right ${isMenuOpen ? 'show' : ''}`}>
          <NavLink to="/" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>
            <span className="nav-link-span">
              <span className="u-nav">Home</span>
            </span>
          </NavLink>
          <NavLink to="/foxandshadow" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>
            <span className="nav-link-span">
              <span className="u-nav">Fox and Shadow</span>
            </span>
          </NavLink>
          <NavLink to="/parselings" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>
            <span className="nav-link-span">
              <span className="u-nav">Parselings</span>
            </span>
          </NavLink>
          <NavLink to="/aboutus" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>
            <span className="nav-link-span">
              <span className="u-nav">About Us</span>
            </span>
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;